import { taskLifecycleModal as taskLifecycleModalDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    param?: string,
};

export const taskLifecycle = ({ param}: Props) => {
    taskLifecycleModalDiagram();
};


